import React from "react"
import * as styles from "./index.module.less"

export default ({
  isDaily = true,
  setDaily = () => null,
  setHourly = () => null,
  className = "",
}) => {
  return (
    <ul className={`${styles.type_selector} ${className}`}>
      <li>
        <button
          className={`btn btn-link ${isDaily ? styles.active : ""}`}
          onClick={setDaily}
        >
          Daily
        </button>
      </li>
      <li>
        <button
          className={`btn btn-link ${!isDaily ? styles.active : ""}`}
          onClick={setHourly}
        >
          Hourly
        </button>
      </li>
    </ul>
  )
}
